import {
  RowGroupingModule,
  SideBarModule,
  PivotModule,
  FiltersToolPanelModule,
  MenuModule,
  ColumnsToolPanelModule,
  IntegratedChartsModule,
  AllEnterpriseModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  LicenseManager,
  ServerSideRowModelModule,
} from 'ag-grid-enterprise';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';

export function registerAgGridEnterpriseModules(): void {
  ModuleRegistry.registerModules([
    AllEnterpriseModule,
    ClientSideRowModelModule,
    RowGroupingModule,
    SideBarModule,
    PivotModule,
    MenuModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ServerSideRowModelModule,
    IntegratedChartsModule.with(AgChartsEnterpriseModule),
  ]);

  LicenseManager.setLicenseKey(
    'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-093208}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{DOMAINEXPERTSGROUP_L.C.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{coreaxis360}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{coreaxis360}_need_to_be_licensed___{coreaxis360}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{19_August_2026}____[v3]_[0102]_MTc4NzA5NDAwMDAwMA==56f2bf648e0b3202227ed56da19b2665'
  );
}
